import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface ComparisonRow {
  criteria: string;
  icon?: string;
  beExpert: string;
  agency: string;
  portals: string;
  isBottomLine?: boolean;
}

@Component({
  selector: 'app-recruiter-why-beexpert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './recruiter-why-beexpert.component.html',
  styleUrls: ['./recruiter-why-beexpert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecruiterWhyBeexpertComponent {
  readonly comparisonRows: ComparisonRow[] = [
    {
      criteria: 'Evaluation',
      icon: 'scan',
      beExpert: 'AI assessment and interview insights',
      agency: 'Resume-based screening',
      portals: 'No structured evaluation'
    },
    {
      criteria: 'Job Match',
      icon: 'target',
      beExpert: 'Skill and job-fit based',
      agency: 'Limited to agency clients',
      portals: 'Candidate filters listings'
    },
    {
      criteria: 'Speed',
      icon: 'zap',
      beExpert: 'Instant assessment and shortlisting',
      agency: 'Slow with follow-ups',
      portals: 'Time-consuming applications'
    },
    {
      criteria: 'Visibility',
      icon: 'bar-chart',
      beExpert: 'Detailed candidate reports',
      agency: 'Resume forwarding only',
      portals: 'CV lost among applications'
    },
    {
      criteria: 'Process',
      icon: 'layers',
      beExpert: 'Assessment-to-placement support',
      agency: 'Recruiter-dependent',
      portals: 'Repeat for every job'
    },
    {
      criteria: 'Cost',
      icon: 'trending-up',
      beExpert: 'Cost-effective hiring solution',
      agency: 'High per-hire costs',
      portals: 'Low upfront cost, but high hiring effort'
    }
  ];
}
